$(".navigation__item a").click(function (e) {
    e.preventDefault();
    if ($(this).parent().hasClass('is-current')) return false; // exit
    const href = $(this).attr("href")
    const tabs = $(this).closest('.navigation__list').find(".navigation__item");
    const tabs__item = $(this).closest('.tabs').find(".tabs__item");
    const next_item = tabs__item.filter(`[data-id='${href}']`);
    const shift = 10;
    animateFromTo(tabs__item.filter(":visible"), 0.25, { x: 0, opacity: 1 }, {
        x: -shift, opacity: 0, ease, onComplete: () => {
            tabs.add(tabs__item).removeClass("is-current");
            $(this).parent().addClass("is-current");
            next_item.addClass("is-current").fadeTo(0, 0).fadeTo(250, 1);
            animateFromTo(next_item, 0.25, { x: shift, opacity: 0 },
                {
                    x: 0, opacity: 1, onComplete: () => {
                        tabs__item.css("transform", '')
                    }
                }, ease);
        }
    });
    if ($(this).closest('.tabs').hasClass("packagesTabs")) {
        const index = tabs__item.filter(`[data-id='${href}']`).index();
        packagesBgRect.css('left', 100 / navigation__item.length * index + "%");
    }
});

let packagesTabs, navigation__item, packagesBgRect;


/* */

$(".navigation__item2 a").click(function (e) {
    e.preventDefault();
    if ($(this).parent().hasClass('is-current')) return false; // exit
    const href2 = $(this).attr("href")
    const tabs2 = $(this).closest('.navigation__list2').find(".navigation__item2");
    const tabs__item2 = $(this).closest('.tabs2').find(".tabs__item2");
    const next_item2 = tabs__item2.filter(`[data-id='${href2}']`);
    const shift2 = 10;
    animateFromTo(tabs__item2.filter(":visible"), 0.25, { x: 0, opacity: 1 }, {
        x: -shift2, opacity: 0, ease, onComplete: () => {
            tabs2.add(tabs__item2).removeClass("is-current");
            $(this).parent().addClass("is-current");
            next_item2.addClass("is-current").fadeTo(0, 0).fadeTo(250, 1);
            animateFromTo(next_item2, 0.25, { x: shift2, opacity: 0 },
                {
                    x: 0, opacity: 1, onComplete: () => {
                        tabs__item2.css("transform", '')
                    }
                }, ease);
        }
    });
    if ($(this).closest('.tabs2').hasClass("packagesTabs2")) {
        const index2 = tabs__item2.filter(`[data-id='${href2}']`).index();
        packagesBgRect2.css('left', 100 / navigation__item2.length * index2 + "%");
    }
});

let packagesTabs2, navigation__item2, packagesBgRect2;

/* */

$(document).ready(function () {
    if ($(".packagesTabs").length) {
        packagesTabs = $(".packagesTabs");
        navigation__item = packagesTabs.find(".navigation__item");
        packagesBgRect = packagesTabs.find(".bgRect");
        navigation__item.width(100 / navigation__item.length + '%')
        packagesBgRect.css("width", `calc(100% / ${navigation__item.length} - 8px)`);


        packagesTabs.find(".packagesList").each(function () {
            const count = $(this).find(".packageItem");
            if (!(count % 3)) {
                $(this).addClass("multiple_3")
            }
        })
    }

/* */

if ($(".packagesTabs2").length) {
    packagesTabs2 = $(".packagesTabs2");
    navigation__item2 = packagesTabs2.find(".navigation__item2");
    packagesBgRect2 = packagesTabs2.find(".bgRect2");
    //navigation__item2.width(100 / navigation__item2.length + '%')
    //packagesBgRect2.css("width", `calc(100% / ${navigation__item2.length} - 8px)`);


    packagesTabs2.find(".packagesList2").each(function () {
        const count2 = $(this).find(".packageItem2");
        if (!(count2 % 3)) {
            $(this).addClass("multiple_3")
        }
    })
}

/* */


});